import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonItem, IonLabel, IonTextarea } from '@ionic/angular/standalone';
import { takeUntil } from 'rxjs/operators';
import { DestroyService } from 'src/app/services/destroy.service';
import { Status } from '../status';

@Component({
  selector: 'app-ssqw-long-text-form',
  templateUrl: './ssqw-long-text-form.component.html',
  styleUrls: ['./ssqw-long-text-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  imports: [FormsModule, ReactiveFormsModule, IonLabel, IonTextarea, IonItem]
})
export class SsqwLongTextFormComponent implements OnInit {
  @Input() initial: string;
  @Input() required: boolean;
  @Input() clearEvent: EventEmitter<void>;
  @Output() status = new EventEmitter<Status>();
  @Output() inputClicked = new EventEmitter<HTMLElement>();

  field = new FormControl('');

  constructor(private destroy$: DestroyService) {}

  ngOnInit(): void {
    if (this.required) this.field.addValidators(Validators.required);
    this.field.addValidators(Validators.pattern(/^(?!\s+$).*/));
    this.field.statusChanges.pipe(takeUntil(this.destroy$)).subscribe((s) => {
      this.status.emit({
        valid: this.field.valid,
        errors: this.field.errors,
        value: this.field.value
      });
    });
    this.field.setValue(this.initial);
    this.clearEvent.pipe(takeUntil(this.destroy$)).subscribe(_ => this.field.setValue(''));
  }

  get length(): number {
    return this.field.value?.length ?? 0;
  }

  onClick(event: MouseEvent): void {
    this.inputClicked.emit(event.target as HTMLElement);
  }
}
